export default __webpack_public_path__ + "static/media/satellite.114abc96.png";